import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateBuddyMatch = props => {
  return (
    <Create
      title='Create Buddy Match'
      fields={fields}
      apiPath='admin/buddy_matches'
      successRedirectPath={resource => `/security/buddy-matches/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateBuddyMatch
